module.exports = __webpack_public_path__ + "img/37118-031.448c0a72.jpg";